import UserProfileFieldsTaskService from 'services/task/subServices/userProfileFieldsTask/UserProfileFieldsTaskService';

export default {
	'services.userProfileFieldsTaskService': {
		class: UserProfileFieldsTaskService,
		deps: [{ $ref: 'services.taskStateService' }, { $ref: 'services.userProfileFieldService' }],
	},
};
